import { render } from "./PolicyExceptionForm.vue?vue&type=template&id=15ec3853&scoped=true"
import script from "./PolicyExceptionForm.vue?vue&type=script&lang=js"
export * from "./PolicyExceptionForm.vue?vue&type=script&lang=js"

import "./PolicyExceptionForm.vue?vue&type=style&index=0&id=15ec3853&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ec3853"]])

export default __exports__